import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-block pt-2" }
const _hoisted_2 = { class: "form-label fw-bolder" }
const _hoisted_3 = { class: "pt-2 has-validation" }
const _hoisted_4 = { class: "form-label fw-bolder" }
const _hoisted_5 = { class: "mt-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_7 = { class: "d-flex justify-content-end mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    show: _ctx.show,
    title: _ctx.t('ImportAliasList'),
    "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:show'))),
    closeOnOuterClick: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("label", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.t('CatalogCode')), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t('File')), 1),
          _createElementVNode("input", {
            type: "file",
            class: "form-control",
            onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onFileUpload($event)))
          }, null, 32)
        ]),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.t('ImportAliasWarning')), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.t('ImportAliasInfo')), 1),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Btn, {
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.close()), ["prevent"])),
            class: "mx-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('Cancel', true)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Btn, {
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.onImport()), ["prevent"])),
            disabled: !_ctx.isFormValid,
            primary: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('Import')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["show", "title"]))
}